<template>
  <div class="warning">
    <div class="content">
      <div class="map" v-show="activeIndex === 1">
        <div class="warning-images">
          <div class="item" v-for="item, index in alarmIcon" :key="item" @click="getColor(index)">
            <img :src="require('@/assets/images/alarmicon/' + item + '.gif')"
              :class="{ 'active': index === activeIconIndex }" />
          </div>
        </div>
        <div class="echart-wrap">
          <div :id="cardEchart ? 'town-warn-cardEchart' : 'town-warn-echart'"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from '@/config/echarts/index.js'
import { mapState } from 'vuex'
import { jsonData, apiData } from '../../../api/index'
export default {
  props: ['cardEchart'],
  data () {
    return {
      areas: ['禅城区', '南海区', '顺德区', '三水区', '高明区'],
      activeIndex: 1,
      activeIconIndex: 0,
      echart: '',
      entryLenght: 0,
      alarmIcon: [],
      WarningAreaColor: [],
      countyAlarm: [],
      townMap: null,
      currentArea: null
    }
  },
  created () {
    const { company } = this.$route.params
    const { unit } = JSON.parse(localStorage.getItem(company))
    this.scope = unit.scope
  },
  watch: {
    activeCountyId: {
      handler () {
        setTimeout(() => {
          this.getTownAlarm()
        }, 100)
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId'])
  },
  mounted () {
    // this.loadEchart()
    window.addEventListener('resize', () => {
      if (this.echart !== '') {
        this.echart.resize()
      }
    })

    this.$bus.$on('changeWarnResize', (data) => {
      this.$nextTick(() => { this.echart.resize() })
    })

    if (this.objsList.length > 0) {
      this.getTownAlarm()
    } else {
      setTimeout(() => {
        this.getTownAlarm()
      }, 3000)
    }

    setInterval(() => {
      this.getTownAlarm()
    }, 5000 * 60)
  },
  methods: {
    /**
     * 加载图表
     */
    async loadEchart () {
      if (this.echart === '') {
        const idName = this.cardEchart ? 'town-warn-cardEchart' : 'town-warn-echart'
        this.echart = echarts.init(document.getElementById(idName))
      }
      const index = this.objsList.findIndex(
        (item) => item.id === this.activeCountyId
      )
      let county = this.objsList[index].county
      // let county = ''
      // 如果获取到区就显示区否则显示佛山市
      if (county) {
        console.log('county', county)
        if (!this.currentArea || county !== this.currentArea) {
          const res = await jsonData.getTownMap(county)
          this.townMap = res
          this.currentArea = county
          echarts.registerMap(this.currentArea, this.townMap)
        }
      } else {
        county = '佛山市'
        const res = await jsonData.getTownMap(county)
        this.townMap = res
        this.currentArea = county
        echarts.registerMap(this.currentArea, this.townMap)
      }

      const option = {
        geo: {
          itemStyle: {
            normal: {
              label: { show: true, textStyle: { color: '#FFF' } },
              borderColor: '#8CAFBB',
              borderWidth: 1.0,
              areaColor: '#1F2C49'
            }
          },
          emphasis: {
            label: { show: true, textStyle: { color: '#FFF' } },
            itemStyle: {
              areaColor: '#1F2C49',
              shadowColor: 'rgba(0, 0, 0, 0.7)',
              shadowOffsetX: -2,
              shadowOffsetY: 2,
              shadowBlur: 10
            }
          },
          type: 'map',
          map: this.currentArea, // chinaMap需要和registerMap中的第一个参数保持一致
          roam: true, // 设置允许缩放以及拖动的效果
          aspectScale: 1,
          // label: {
          //   show: true // 展示标签
          // },
          zoom: 1.2, // 设置初始化的缩放比例
          regions: this.WarningAreaColor
        },
        nameProperty: '乡镇名',
        series: [
          {
            type: 'map',
            map: '佛山',
            geoIndex: 0,
            data: this.WarningAreaColor
          }
        ]
      }
      this.echart.clear()
      this.echart.setOption(option)
      this.echart.resize()
    },
    /**
     * 正在生效的区县预警信号
     */
    async getTownAlarm () {
      const countyAlarm = []
      const result = await apiData.townAlarm()
      const index = this.objsList.findIndex(
        (item) => item.id === this.activeCountyId
      )
      const county = this.objsList[index].county
      const arr = result[county] ? result[county] : []
      countyAlarm.push(...arr)
      this.alarmIcon = []
      countyAlarm.forEach(item => {
        const alarnIcon = item.signame + item.siglevel
        const index = this.alarmIcon.findIndex(iten => iten.includes(item.signame))
        if (index < 0) {
          this.alarmIcon.push(alarnIcon)
        } else {
          const num = Number(this.alarmIcon[index].split('')[1])
          if (item.siglevel > num) {
            this.alarmIcon[index] = alarnIcon
          }
        }
      })
      this.countyAlarm = countyAlarm
      this.getColor(0)
    },

    getColor (index) {
      this.activeIconIndex = index
      const WarningAreaColor = []
      const signame = this.alarmIcon[index]
      this.areas.forEach((street, index) => {
        let color = '#33446A'
        this.countyAlarm.forEach((alarm) => {
          if (alarm.county === street && signame.includes(alarm.signame)) {
            color = alarm.sigcolor
            const areaData = {
              name: alarm.town,
              aname: alarm.aname,
              ddatetime: alarm.ddatetime,
              sigcolor: alarm.sigcolor,
              // content: this.getAlarmContent(alarm.aname),
              itemStyle: {
                areaColor: alarm.sigcolor
              },
              emphasis: { itemStyle: { areaColor: alarm.sigcolor } }
            }
            WarningAreaColor.push(areaData)
          }
        })
      })
      this.WarningAreaColor = WarningAreaColor
      this.loadEchart()
    }
  }
}
</script>
<style lang="less" scoped>
.warning {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 6.2vh 1.04vw 0vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;

  .tabs {
    position: absolute;
    right: 0.21vw;
    top: 1.04vw;
    z-index: 99;

    button {
      width: 2.45vw;
      height: 1.09vw;
      padding: 0;
      border-radius: 0.16vw;
      border: 0.05vw solid #FFFFFF;
      margin-right: 0.63rem;
      color: #FFF;
      font-size: 12px;
      color: #FFF;
      background: #30395C;
      cursor: pointer;
      line-height: 1.09vw;
    }

    button.active {
      color: #89C3F2;
      border: 0.05vw solid #89C3F2;
    }
  }

  .content {
    position: relative;
    flex: 1;

    .list {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;

      .warning-images {
        display: flex;
        justify-content: space-between;
        margin: 0.5rem 0 0.5rem;
        position: relative;
        z-index: 9;

        .item {
          height: 2rem;
          background: transparent;
          text-align: center;

          img {
            margin: 0 auto;
          }
        }
      }

      .item {
        display: flex;
        width: 7.23rem;
        height: 60%;
        background: #e9edf3;
        border-radius: 0.38rem;
      }
    }

    .map {
      display: flex;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;

      .warning-images {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        min-width: 4vw;
        position: relative;
        z-index: 9;

        .item {
          box-sizing: border-box;
          margin-bottom: 0.5rem;
          margin-right: 0.42vw;

          img {
            width: 3rem;

            &:hover {
              cursor: pointer;
            }
          }

          .active {
            border: 0.1vw solid #00ddff;
          }
        }
      }

      .echart-wrap {
        height: 100%;
        width: 100%;

        #town-warn-echart,
        #town-warn-cardEchart {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }
      }
    }
  }
}
</style>
